export default __webpack_public_path__ + "static/media/ai.5885bdb1.png";